<template>
  <div class="line contPadding">
    <div class="main-title">组织机构管理</div>
    <el-row class="content-container">
      <el-col :span="7" style="border-right: 1px solid #d9e4f4;">
        <div class="selectList">
          <div class="title"><span></span>组织机构树：</div>
          <div class="custom-tree-container">
            <el-tree
              ref="elTree"
              :props="props"
              :load="rootloadNode"
              lazy
              :render-content="renderContent"
              :expand-on-click-node="false"
            ></el-tree>
          </div>
        </div>
      </el-col>
      <el-col :span="17">
        <div class="content">
          <el-form
            :model="ruleForm"
            :rules="rules"
            ref="ruleForm"
            label-width="100px"
            class="demo-ruleForm formTop"
            :disabled="formDisabled"
          >
            <div class="title"><span></span>基本信息：</div>
            <el-row :gutter="20">
              <el-col :span="10">
                <el-form-item label="代码" prop="orgCode">
                  <el-input v-model.trim="ruleForm.orgCode"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="10">
                <el-form-item label="简码" prop="orgCodeAbbr">
                  <el-input v-model.trim="ruleForm.orgCodeAbbr"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="10">
                <el-form-item label="名称" prop="orgName">
                  <el-input v-model.trim="ruleForm.orgName"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="10">
                <el-form-item label="简称" prop="orgNameAbbr">
                  <el-input v-model.trim="ruleForm.orgNameAbbr"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="10">
                <el-form-item label="性质" prop="orgType">
                  <el-select v-model="ruleForm.orgType">
                    <el-option label="部门" value="dept"></el-option>
                    <el-option label="单位" value="unit"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="10">
                <el-form-item label="行政区划" class="input">
                  <el-input
                    @click.native="inputTree"
                    v-model="ruleForm.orgRegionName"
                    readonly
                  />
                  <!--  <div class="orgRegionCode_input" @click="inputTree">
                    {{ ruleForm.orgRegionName }}
                  </div> -->
                  <div class="backTree" v-show="treeShow">
                    <div class="tree">
                      <div class="title"><span></span>行政区划：</div>
                      <div type="primary" class="sureBtn" @click="sureClick">
                        确定
                      </div>
                      <div class="closeBtn" @click="closeClick">取消</div>
                      <el-tree
                        ref="tree"
                        :props="props"
                        :load="loadNode"
                        lazy
                        node-key="id"
                        show-checkbox
                      ></el-tree>
                    </div>
                  </div>
                </el-form-item>
              </el-col>
              <el-col :span="10">
                <el-form-item label="上级">
                  <el-input
                    v-model="ruleForm.parent"
                    :disabled="upData"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="10">
                <el-form-item label="排序">
                  <el-input v-model="ruleForm.orgSortNum"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <div class="title"><span></span>扩展信息：</div>
            <el-row :gutter="20" style="margin-top:20px;">
              <el-col :span="10">
                <el-form-item label="机构负责人">
                  <el-input v-model="ruleForm.orgMasterName"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="10">
                <el-form-item label="机构电话">
                  <el-input
                    v-model="ruleForm.orgPhone"
                    maxlength="11"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="10">
                <el-form-item label="机构邮箱">
                  <el-input v-model="ruleForm.orgMail"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="10">
                <el-form-item label="邮政编码">
                  <el-input v-model="ruleForm.orgZipCode"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="10">
                <el-form-item label="监察类型">
                  <el-select v-model="ruleForm.superviseType">
                    <el-option label="生产企业" value="1" />
                    <el-option label="经营企业" value="0" />
                    <el-option label="零售药店" value="2" />
                    <el-option label="医疗机构" value="3" />
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="10">
                <el-form-item label="监察区域">
                  <el-input
                    @click.native="inputTree_JG"
                    v-model="ruleForm.superviseAreaName"
                    readonly
                  />
                  <div class="backTree" v-show="treeShow_JG">
                    <div class="tree">
                      <div class="title"><span></span>监察区域</div>
                      <div class="sureBtn" @click="sureClick_JG">确定</div>
                      <div class="closeBtn" @click="closeClick">取消</div>
                      <el-tree
                        ref="tree_JG"
                        :props="propsJG"
                        :load="loadNodeJG"
                        lazy
                        node-key="id"
                        show-checkbox
                      ></el-tree>
                    </div>
                  </div>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
          <div class="submitBtn">
            <el-button
              type="primary"
              @click="submitForm('ruleForm')"
              class="special-btn"
              v-if="!formDisabled"
              >保存并更新</el-button
            >
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>
<script>
export default {
  data() {
    return {
      formDisabled: false,
      inputTreeDate: '',
      treeShow: false,
      treeShow_JG: false,
      props: {
        label: 'name',
        children: 'zones',
        isLeaf: 'leaf'
      },
      propsJG: {
        label: 'name',
        children: 'zones',
        isLeaf: 'leaf'
      },
      data: [],
      ID: '',
      ID1: '',
      upData: true,
      count: 1,
      ruleForm: {
        orgCode: '',
        orgCodeAbbr: '',
        orgName: '',
        orgNameAbbr: '',
        orgType: '',
        orgRegionCode: '',
        orgRegionName: '',
        parent: '',
        orgSortNum: '',
        orgMasterName: '',
        orgPhone: '',
        orgMail: '',
        orgZipCode: '',
        superviseType: '',
        superviseAreaCode: '',
        superviseAreaName: '',
        method: 'add',
        id1: '',
        id2: '',
        parentId: '',
        parentName: ''
      },
      rules: {
        orgCode: [
          { required: true, message: '请输入正确的代码', trigger: 'blur' }
        ],
        orgCodeAbbr: [
          {
            required: true,
            message: '请输入正确的简码',
            trigger: 'blur'
          }
        ],
        orgName: [
          { required: true, message: '请输入正确的名称', trigger: 'blur' }
        ],
        orgNameAbbr: [
          { required: true, message: '请输入正确的简称', trigger: 'blur' }
        ],
        orgType: [{ required: true, message: '请选择性质', trigger: 'blur' }],
        orgSortNum: [
          {
            required: false,
            message: '请填写排序数字',
            pattern: /^\d+$/,
            trigger: 'blur'
          }
        ]
      },
      parentId: '',
      orgId: '',
      arrvalue: '',
      removeOrgId: '',
      node: [],
      resolve: [],
      initRuleForm: {}
    };
  },
  methods: {
    changeClick(data) {
      this.formDisabled = false;
      this.$refs.ruleForm.clearValidate();
      this.ruleForm.method = 'update';
      this.loadOrgById(data.code);
    },
    resetruleForm() {
      for (const key in this.ruleForm) {
        if (key !== 'method') {
          this.ruleForm[key] = '';
        }
      }
    },
    // 组织机构树
    rootloadNode(node, resolve) {
      if (node.level === 0) {
        this.node = node;
        this.resolve = resolve;
        this.parentId = 'root';
        return resolve([{ name: '组织机构树' }]);
      }
      if (node.level > 1) {
        this.parentId = node.data.code;
      }
      this.$request({
        url: 'rest/bsp/pubOrganInfo/loadOrgByPid',
        data: {
          parentId: this.parentId
        }
      }).then(res => {
        this.data = res;
        resolve(res);
      });
    },
    // form表单明细
    loadOrgById(dataID) {
      this.$request({
        url: 'rest/bsp/pubOrganInfo/loadOrgById',
        data: {
          orgId: dataID
        }
      }).then(res => {
        this.ruleForm.id1 = res.pubOrganInfo.id;
        this.ruleForm.orgCode = res.pubOrganInfo.orgCode;
        this.ruleForm.orgCodeAbbr = res.pubOrganInfo.orgCodeAbbr;
        this.ruleForm.orgName = res.pubOrganInfo.orgName;
        this.ruleForm.orgNameAbbr = res.pubOrganInfo.orgNameAbbr;
        if (res.pubOrganInfo.orgType === 'unit') {
          this.ruleForm.orgType = '单位';
        }
        if (res.pubOrganInfo.orgType === 'dept') {
          this.ruleForm.orgType = '部门';
        }
        this.ruleForm.orgRegionCode = res.pubOrganInfo.orgRegionCode;
        this.ruleForm.orgRegionName = res.pubOrganInfo.orgRegionName;
        this.ruleForm.orgSortNum = res.pubOrganInfo.orgSortNum;
        this.ruleForm.parentId = res.pubOrganInfo.parentId;
        this.ruleForm.parentName = res.pubOrganInfo.parentName;
        this.ruleForm.parent = res.pubOrganInfo.parentName;
        this.ruleForm.id2 = res.pubOrganExt.id;
        this.ruleForm.orgMasterName = res.pubOrganExt.orgMasterName;
        this.ruleForm.orgPhone = res.pubOrganExt.orgPhone;
        this.ruleForm.orgMail = res.pubOrganExt.orgMail;
        this.ruleForm.orgZipCode = res.pubOrganExt.orgZipCode;
        this.ruleForm.superviseType = res.pubOrganExt.superviseType;
        if (res.pubOrganExt.superviseType === '0') {
          this.ruleForm.superviseType = '经营企业';
        }
        if (res.pubOrganExt.superviseType === '1') {
          this.ruleForm.superviseType = '生产企业';
        }
        if (res.pubOrganExt.superviseType === '2') {
          this.ruleForm.superviseType = '零售药店';
        }
        if (res.pubOrganExt.superviseType === '3') {
          this.ruleForm.superviseType = '医疗机构';
        }
        this.ruleForm.superviseAreaCode = res.pubOrganExt.superviseAreaCode;
        this.ruleForm.superviseAreaName = res.pubOrganExt.superviseAreaName;
      });
    },
    remove(node, data) {
      this.$confirm('是否确认删除？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        if (data.name === '组织机构树') {
          this.$message.error('组织机构树不可删除');
          return;
        }
        this.$request({
          url: 'rest/bsp/pubOrganInfo/deleteOrgan',
          data: {
            orgId: node.data.code
          }
        }).then(res => {
          this.node.childNodes = [];
          this.rootloadNode(this.node, this.resolve);
        });
      });
    },
    watchInfo(data) {
      if (data.name === '组织机构树') {
      } else {
        this.formDisabled = true;
        this.$refs.ruleForm.clearValidate();
        this.ruleForm.parent = data.parentName;
        this.ruleForm.method = 'add';
        this.loadOrgById(data.code);
      }
    },
    renderContent(h, { node, data, store }) {
      return (
        <span class="custom-tree-node">
          <span on-click={() => this.watchInfo(data)}>{node.label}</span>
          <span>
            <el-button
              size="mini"
              type="text"
              class="tree-btn"
              on-click={() => this.append(data)}
            >
              新增
            </el-button>
            <el-button
              size="mini"
              type="text"
              class="tree-btn"
              on-click={() => this.changeClick(data)}
            >
              编辑
            </el-button>
            <el-button
              size="mini"
              type="text"
              class="tree-btn"
              on-click={() => this.remove(node, data)}
            >
              删除
            </el-button>
          </span>
        </span>
      );
    },
    // 行政区划input点击树
    inputTree() {
      if (this.formDisabled) {
        return;
      }
      this.treeShow = true;
    },
    inputTree_JG() {
      this.treeShow_JG = true;
    },
    // 行政区划提交确认按钮
    sureClick() {
      this.treeShow = false;
      const res = this.$refs.tree.getCheckedNodes();
      const arr = [];
      const arrcode = [];
      res.forEach(item => {
        arr.push(item.name);
        arrcode.push(item.code);
      });
      this.ruleForm.orgRegionName = arr.join(','); // 行政区划名字
      this.ruleForm.orgRegionCode = arrcode.join(','); // 行政区划code
    },
    // 监管区划提交确认按钮
    sureClick_JG() {
      this.treeShow_JG = false;
      const resJG = this.$refs.tree_JG.getCheckedNodes();
      const arrJG = [];
      const arrJGcode = [];
      resJG.forEach(item => {
        arrJG.push(item.name);
        arrJGcode.push(item.code);
      });
      this.ruleForm.superviseAreaName = arrJG.join(','); // 监管区划名字
      this.ruleForm.superviseAreaCode = arrJGcode.join(','); // 监管区划code
    },
    // 关闭
    closeClick() {
      this.treeShow = false;
      this.treeShow_JG = false;
    },
    // 行政区划
    loadNode(node, resolve) {
      if (node.level === 0) {
        this.ID = 'CN';
        return resolve([{ name: '中华人民共和国', disabled: true }]);
      }
      if (node.level > 1) {
        this.ID = node.data.code;
      }
      this.$request({
        url: 'rest/bsp/pubCant/loadRegionByPid',
        data: {
          parentId: this.ID
        }
      }).then(res => {
        resolve(res);
      });
    },
    // 监管区划
    loadNodeJG(node, resolve) {
      if (node.level === 0) {
        this.ID1 = 'CN';
        return resolve([{ name: '中华人民共和国', disabled: true }]);
      }
      if (node.level > 1) {
        this.ID1 = node.data.code;
      }
      this.$request({
        url: 'rest/bsp/pubCant/loadRegionByPid',
        data: {
          parentId: this.ID1
        }
      }).then(res => {
        resolve(res);
      });
    },
    // 添加保存
    mergeOrgInfo(objData) {
      if (objData.superviseType === '经营企业') {
        objData.superviseType = '0';
      }
      if (objData.superviseType === '生产企业') {
        objData.superviseType = '1';
      }
      if (objData.superviseType === '零售药店') {
        objData.superviseType = '2';
      }
      if (objData.superviseType === '医疗机构') {
        objData.superviseType = '3';
      }
      if (objData.orgType === '单位') {
        objData.orgType = 'unit';
      }
      if (objData.orgType === '部门') {
        objData.orgType = 'dept';
      }

      const obj = {
        method: objData.method,
        baseInfo: {
          id: objData.id1,
          orgCode: objData.orgCode,
          orgCodeAbbr: objData.orgCodeAbbr,
          orgName: objData.orgName,
          orgNameAbbr: objData.orgNameAbbr,
          orgType: objData.orgType,
          orgRegionCode: objData.orgRegionCode,
          orgRegionName: objData.orgRegionName,
          orgRegionId: objData.orgRegionId,
          orgSortNum: objData.orgSortNum,
          parentId: objData.parentId,
          parentName: objData.parentName
        },
        extInfo: {
          id: objData.id2,
          orgMail: objData.orgMail,
          orgMasterName: objData.orgMasterName,
          orgPhone: objData.orgPhone,
          orgZipCode: objData.orgZipCode,
          superviseAreaName: objData.superviseAreaName,
          superviseAreaCode: objData.superviseAreaCode,
          superviseType: objData.superviseType
        }
      };
      this.$request({
        url: 'rest/bsp/pubOrganInfo/mergeOrgInfo',
        data: {
          jsonStr: JSON.stringify(obj)
        }
      }).then(res => {
        this.$message({
          message: obj.method === 'add' ? '新增成功' : '修改成功',
          type: 'success'
        });
        this.formDisabled = true;
        this.node.childNodes = [];
        this.rootloadNode(this.node, this.resolve);
      });
    },
    // 新增--
    append(data) {
      this.formDisabled = false;
      this.$refs.ruleForm.clearValidate();
      this.resetruleForm();
      if (data.name === '组织机构树') {
        this.ruleForm.parent = '组织机构树';
        this.ruleForm.parentId = 'root';
        this.ruleForm.parentName = '组织机构树';
      } else {
        this.ruleForm.parent = data.name;
        this.ruleForm.parentId = data.code;
        this.ruleForm.parentName = data.name;
      }
    },
    // 表单判断
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.mergeOrgInfo(this.ruleForm);
        } else {
          return false;
        }
      });
    },
    resetForm(formName) {
      for (const key in this.initRuleForm) {
        this.ruleForm[key] = this.initRuleForm[key];
      }
    }
  }
};
</script>
<style>
.el-tree-node__content {
  font-size: 14px !important;
}
.el-form-item.is-success .el-input__inner,
.el-form-item.is-success .el-input__inner:focus,
.el-form-item.is-success .el-textarea__inner,
.el-form-item.is-success .el-textarea__inner:focus {
  border-color: #d9d9d9;
}
.el-input.is-disabled .el-input__inner {
  background: none !important;
  border-color: #e4e7ed;
  color: #5a5e66;
  cursor: not-allowed;
}
</style>

<style lang="stylus" scoped>
@import './common.styl'
.selectList
  height 100vh
  width 100%
  background #fff
.content
  background #fff
  height 100vh
  overflow hidden
  .bottom
    margin 10px 0 5px 0
  .msg
    width 100%
    margin 0 0 0 20px
    height auto
    overflow hidden
    li
      list-style none
      width 45%
      float left
      font-size 12px
      color #606266
      height 40px
      line-height 40px
      margin 5px 0 0 0
      display inline-block
      overflow hidden
      white-space nowrap
      text-overflow ellipsis
      span
        margin-left 10px
.formTop
  margin-top 15px
.submitBtn
  margin 30px auto
  text-align center
.orgRegionCode_input
  -webkit-appearance none
  background-color #fff
  border-radius 0
  border 1px solid #d9d9d9
  box-sizing border-box
  color #5b5f67
  display inline-block
  height 30px
  line-height 30px
  outline 0
  width 100%
  cursor pointer
  margin-top 6px
  font-size 12px
  text-align left
  padding-left 10px
  overflow hidden
  white-space nowrap
  text-overflow ellipsis
.custom-tree-node
  flex 1
  display flex
  align-items center
  justify-content space-between
  font-size 12px !important
  padding-right 8px
  .el-button--text
    margin-left 20px
  span
    font-size 12px !important
.backTree
  width 100%
  height 100%
  position fixed
  top 0
  left 0
  background rgba(0, 0, 0, 0.5)
  z-index 10000
  .tree
    position absolute
    top 25%
    left 40%
    width 500px
    height 400px
    background #fff
    padding 20px 0 0 20px
    overflow auto
    overflow-x hidden
  .sureBtn
    position absolute
    top 8px
    right 80px
    height 30px
    line-height 30px
    cursor pointer
    background #409eff
    border 1px solid #409eff
    color #fff
    padding 0 10px
  .closeBtn
    height 30px
    line-height 30px
    position absolute
    top 8px
    right 10px
    cursor pointer
    border 1px solid #409eff
    background #fff
    color #409eff
    padding 0 10px
.cancel
  color #999
  font-size 15px
  margin-left 25px
  cursor pointer
  &:hover
    color #409EFF
>>>.tree-btn
  padding 0 5px
  height 31px
  line-height 31px
  margin 0 !important
</style>
